export const GET_TEMPLATE_GUBUN_LIST = "GET_TEMPLATE_GUBUN_LIST";
export const GET_TEMPLATE_LIST = "GET_TEMPLATE_LIST";
